<template>
  <modal name="report-infestation" transition="pop-out" width="50%" height="60%">
    <form action="#">
      <div class="report-card-square mdl-card mdl-shadow--2dp">
        <div class="mdl-card__title mdl-card--expand">
          <h2 class="mdl-card__title-text">REPORT INFESTATION</h2>
        </div>
        <div class="mdl-card__supporting-text">
          <div class="mdl-grid">
            <!-- form start -->

            <div class="mdl-cell mdl-cell--3-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <label class="mdl-textfield__label" for="label">Add an optional label:</label>
            </div>
            <div class="mdl-cell mdl-cell--7-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <input class="mdl-textfield__input" placeholder="My garden shed ..." type="text" id="label">
            </div>
            <div class="mdl-cell mdl-cell--3-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <label class="mdl-textfield__label" for="address">Address:</label>
            </div>
            <div class="mdl-cell mdl-cell--7-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <gmap-autocomplete
                class='mdl-textfield__input'
                placeholder='type here'
                @place_changed="addLocation"
                >
              </gmap-autocomplete>
            </div>

            <div class="mdl-cell mdl-cell--3-col">
              <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="checkbox-1">
                <span class="mdl-checkbox__label">Infestation resolved</span>
              </label>
            </div>
            <div class="mdl-cell mdl-cell--1-col">
              <input type="checkbox" id="checkbox-1" class="mdl-checkbox__input">
            </div>

            <!-- form end -->
          </div>
        </div>
      </div>

      <!-- <div class="mdl-card__supporting-text report-bug-card-image">
        <svgicon icon="green_bug_card"
                 class="appicon-bug appicon-icon"
                 :original="true"
                 >
        </svgicon>
      </div> -->
      <div class="mdl-card__actions mdl-card--border">
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--4-coll">
            <ripple-button
              class="report-card-button"
              @click.native="addReportPhoto()"
              >
              Add photo
            </ripple-button>
          </div>
          <div class="mdl-cell mdl-cell--4-coll">
            <ripple-button
              class="report-card-button"
              @click.native="cancelReportModal()"
              >
              Cancel
            </ripple-button>
          </div>
          <div class="mdl-cell mdl-cell--4-coll">
            <ripple-button
              class="report-card-button"
              @click.native="SubmitReportForm()"
              >
              Submit
            </ripple-button>
          </div>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>

import 'icons/green_bug_card'
import RippleButton from '@/components/RippleButton'

export default {
  name: 'ReportInfestationModal',
  components: {
    RippleButton
  },
  methods: {
    addLocation (place) {
      this.$store.dispatch('addLocation', place)
    },
    addReportPhoto () {
      console.log('addReportPhoto() clicked')
    }
  }
}
</script>

<style scoped>
.report-card-square {
  height:100%

}

.report-card-square.mdl-card {
  width: 100%;
  height: 100%;
}
.report-card-square > .mdl-card__title {
  color: #36623E;
}

.report-bug-card-image {
  width: 35%;
  position:relative;
  display:flex;
  justify-content:center;
  align-items:center;
  overflow:hidden;
  text-align: right;
}

.report-bug-card-image svg {
  flex-shrink:0;
  min-width:80%;
  min-height:80%;
  float: right;
}

.report-bug-card-square > .report-bug-card-button {
  color: #36623E;
}

</style>



// WEBPACK FOOTER //
// src/components/ReportInfestationModal.vue